export default __webpack_public_path__ + "static/media/8_4_0.83817a18.png";